module.exports = __webpack_public_path__ + "img/Puente_Istobal_FLEX5_3_Extended_Alto_Blanco-default-back.64445d04.jpg";